// companionContext - tells the guide which module the reader has open.
//
// The guide chat opens over a module (from a "Chat with" card in the module,
// or from the floating guide button while the module is on screen). The
// Knowledge Hub renders currentModule, moduleName and sectionName as module
// revision context, so the guide can talk about what the reader is reading.
//
// ModuleRenderer records the module and part on screen here while it is
// mounted and clears it when the module closes. Memory only: nothing is
// written to storage, and a reload starts with nothing.

let reading = null;

export const setReadingModule = (mod) => {
  reading = mod && mod.id != null && mod.title
    ? { id: mod.id, title: mod.title, section: mod.section || null }
    : null;
};

export const getReadingModule = () => reading;

// The userContext fields for a module, or none without one.
export const moduleUserContext = (mod) => (mod && mod.id != null && mod.title
  ? {
    currentModule: String(mod.id),
    moduleName: mod.title,
    ...(mod.section ? { sectionName: mod.section } : {}),
  }
  : {});

// Only filled-in values are sent, because the Hub would turn a missing one
// into the word "null"; a module's name or section goes only with the module
// itself, since without it the Hub renders nothing.
const MODULE_DETAIL_KEYS = ['moduleName', 'sectionId', 'sectionName'];

export function cleanUserContext(userContext = {}) {
  const out = {};
  for (const [key, value] of Object.entries(userContext || {})) {
    if (value === null || value === undefined || value === '') continue;
    out[key] = value;
  }
  if (out.currentModule === undefined) {
    MODULE_DETAIL_KEYS.forEach((key) => { delete out[key]; });
  } else {
    out.currentModule = String(out.currentModule);
  }
  return out;
}
